import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import BEM from '@iui-kit/utils/bem'

const bem = new BEM(require('./GroupHead.css'))

interface Props {
  title: string
  subTitle?: string
  notRequired?: boolean
}

const GroupHead: React.FC<Props> = ({ title, subTitle, notRequired, children }) => {
  return (
    <div className={bem.b('GroupHead').show()}>
      <div
        className={bem
          .b('GroupHead')
          .e('title')
          .show()}
      >
        <FormattedHTMLMessage id={title} />
        {children}

        {notRequired && (
          <span
            className={bem
              .b('GroupHead')
              .e('not-required')
              .show()}
          >
            <FormattedHTMLMessage id="Brief.notRequired" />
          </span>
        )}
      </div>
      {subTitle && (
        <div
          className={bem
            .b('GroupHead')
            .e('sub-title')
            .show()}
        >
          <FormattedHTMLMessage id={subTitle} />
        </div>
      )}
    </div>
  )
}

export default GroupHead
